import React from "react";
import Button, { ButtonProps } from "src/components/core/Button";
import { InkedLogo } from "./InkedLogo";

type InkedButtonProps = ButtonProps;

const InkedButton: React.FC<InkedButtonProps> = (props) => (
  <Button icon={<InkedLogo color="white" className="h-4" />} {...props} />
);

export default InkedButton;
